import { create } from "zustand";

export const CHAT_BUBBLE_THEMES = {
  default: {
    id: "default",
    name: "Classic Slate",
    description: "Sleek standard theme with native accents",
    price: 0,
    myBubble: "bg-primary text-primary-content",
    otherBubble: "bg-base-200 text-base-content",
    previewGradient: "from-primary to-primary-focus",
  },
  cyberpunk: {
    id: "cyberpunk",
    name: "Cyberpunk Neon",
    description: "Electric cyan with magenta neon glow",
    price: 500,
    myBubble: "bg-gradient-to-r from-cyan-500 to-fuchsia-600 text-white shadow-[0_0_15px_rgba(6,182,212,0.4)] border border-cyan-400/40",
    otherBubble: "bg-slate-900/90 text-cyan-200 border border-fuchsia-500/30 shadow-[0_0_10px_rgba(217,70,239,0.2)]",
    previewGradient: "from-cyan-500 to-fuchsia-500",
  },
  sunset: {
    id: "sunset",
    name: "Sunset Ember",
    description: "Warm amber to vibrant rose gold gradient",
    price: 750,
    myBubble: "bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 text-white shadow-[0_0_15px_rgba(245,158,11,0.35)] border border-amber-300/30",
    otherBubble: "bg-neutral-900/90 text-amber-100 border border-amber-500/30 shadow-sm",
    previewGradient: "from-amber-500 to-rose-500",
  },
  midnight: {
    id: "midnight",
    name: "Midnight Amethyst",
    description: "Deep obsidian with royal violet glow",
    price: 600,
    myBubble: "bg-gradient-to-r from-purple-700 via-indigo-600 to-violet-700 text-white shadow-[0_0_15px_rgba(147,51,234,0.4)] border border-purple-400/30",
    otherBubble: "bg-zinc-900/90 text-purple-200 border border-purple-500/30 shadow-sm",
    previewGradient: "from-purple-600 to-indigo-600",
  },
  emerald: {
    id: "emerald",
    name: "Emerald Matrix",
    description: "Lush cyber jade and neon emerald glow",
    price: 600,
    myBubble: "bg-gradient-to-r from-emerald-600 to-teal-500 text-white shadow-[0_0_15px_rgba(16,185,129,0.4)] border border-emerald-400/40",
    otherBubble: "bg-neutral-900/90 text-emerald-200 border border-emerald-500/30 shadow-sm",
    previewGradient: "from-emerald-500 to-teal-500",
  },
};

export const useThemeStore = create((set) => ({
  theme: localStorage.getItem("chat-theme") || "light",
  chatBubbleTheme: localStorage.getItem("chat-bubble-theme") || "default",
  unlockedBubbleThemes: JSON.parse(localStorage.getItem("unlocked-bubble-themes") || '["default"]'),
  setTheme: (theme) => {
    localStorage.setItem("chat-theme", theme);
    set({ theme });
  },
  setChatBubbleTheme: (bubbleTheme) => {
    localStorage.setItem("chat-bubble-theme", bubbleTheme);
    set({ chatBubbleTheme: bubbleTheme });
  },
  unlockChatBubbleTheme: (bubbleTheme) => {
    set((state) => {
      if (state.unlockedBubbleThemes.includes(bubbleTheme)) return state;
      const updated = [...state.unlockedBubbleThemes, bubbleTheme];
      localStorage.setItem("unlocked-bubble-themes", JSON.stringify(updated));
      return { unlockedBubbleThemes: updated };
    });
  },
}));
